import { render } from "./enrollData.vue?vue&type=template&id=4ac2a8b3&scoped=true"
import script from "./enrollData.vue?vue&type=script&lang=js"
export * from "./enrollData.vue?vue&type=script&lang=js"

import "./enrollData.vue?vue&type=style&index=0&id=4ac2a8b3&scoped=true&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac2a8b3"]])

export default __exports__